module.exports = __webpack_public_path__ + "img/btn_TOEIC_strategy_on.38fcc9f8.png";